import type { B2XActiveProfileState, B2XActiveProfilePersistedState } from '../state';

export const loadPersistentStateFromSessionStorage = (
  persistedState: B2XActiveProfilePersistedState,
): B2XActiveProfileState => {
  return { ...persistedState };
};

export const savePersistentStateToSessionStorage = (state: B2XActiveProfileState): B2XActiveProfilePersistedState => {
  return { ...state };
};
